module.exports = __webpack_public_path__ + "img/cancel.de167fe0.svg";